/* eslint-disable */
import {gsap} from 'gsap';
import {isTouch} from './../../utils/detect-device';

/**
 * Creates custom cursor
 * @class
 * How to use
 * @example
 * const cursor = new Cursor();
 * cursor.init();
 */
export default class {
  constructor() {
    /** Acting cursor element */
    this.cursor = document.querySelector('.js-cursor');
    /**
     * Default hovered elements: all links, buttons, form elements.
     * For exeption use class 'js-no-hovered'.
     * For making hovered any element use class 'js-hovered'.
     */
    this.hoveredSelectors = 'a:not(.js-no-hovered), ' +
      'button:not(.js-no-hovered), ' +
      'input:not(.js-no-hovered), ' +
      'textarea:not(.js-no-hovered), ' +
      'select:not(.js-no-hovered), ' +
      '[class*=button]:not(.js-no-hovered), ' +
      '[class*=btn]:not(.js-no-hovered), ' +
      '[class*=link]:not(.js-no-hovered), ' +
      '.js-hovered, ' +
      '[role=button]';

    this.hoveredElems = document.querySelectorAll(`${this.hoveredSelectors}`);
    
    /** Cursor start position at page center */
    this.cursorLeftPosition = document.documentElement.clientWidth / 2;
    this.cursorTopPosition = document.documentElement.clientHeight / 2;
  }

  hideDefaultCursor() {
    const style = document.createElement('style');
    style.classList.add('removeCursorStyle');
    style.innerHTML = '* {cursor: none !important;}';
    document.body.appendChild(style);
  }

  showDefaultCursor() {
    let style = document.querySelector('.removeCursorStyle');
    if (style) {
      style.remove();
    }
  }

  showCustomCursor() {
    this.cursor.classList.remove('cursor--hidden');
  }

  hideCustomCursor() {
    this.cursor.classList.add('cursor--hidden');
  }

  /** Move cursor element on page */
  moveCursor() {
    document.addEventListener("mousemove", e => {
      this.cursorLeftPosition = e.clientX;
      this.cursorTopPosition = e.clientY;

      gsap.set(this.cursor, {
        x: this.cursorLeftPosition,
        y: this.cursorTopPosition
      })
    });
  }

  /** Add default hover state */
  cursorOver() {
    this.cursor.classList.add('cursor--hovered');
    this.cursor.classList.remove('cursor--close');
  }

  /** Remove default hover state */
  cursorOut() {
    this.cursor.classList.remove('cursor--hovered');
    this.cursor.classList.remove('cursor--right-arrow');
    this.cursor.classList.remove('cursor--left-arrow');
    this.cursor.classList.remove('cursor--close');
  }

  /** Add default hover state */
  cursorSliderOver() {
    let windowWidthHalf = window.innerWidth / 2;
    if (this.cursorLeftPosition < windowWidthHalf) {
      this.cursor.classList.add('cursor--left-arrow');
      this.cursor.classList.remove('cursor--right-arrow');
    } else {
      this.cursor.classList.add('cursor--right-arrow');
      this.cursor.classList.remove('cursor--left-arrow');
    }
  }

  /** Remove default hover state */
  cursorSliderOut() {
    this.cursor.classList.remove('cursor--hovered');
    this.cursor.classList.remove('cursor--right-arrow');
    this.cursor.classList.remove('cursor--left-arrow');
  }

  /** Add default hover state */
  cursorCloseOver() {
    this.cursor.classList.add('cursor--close');
  }

  /** Remove default hover state */
  cursorCloseOut() {
    this.cursor.classList.remove('cursor--hovered');
    this.cursor.classList.remove('cursor--close');
  }

  /** Remove all hover states */
  resetCursor() {
    this.cursorOut();
  }

  /** Toggle cursor hover state by mouseover and mouseout events */
  toggleHoverState() {

    document.addEventListener('mouseover', (event) => {
      const target = event.target;
      if (target.matches(`${this.hoveredSelectors}`) || target.closest(`${this.hoveredSelectors}`)) {
        this.cursorOver();
      }
    });

    document.addEventListener('mouseout', (event) => {
      const target = event.target;
      if (target.matches(`${this.hoveredSelectors}`) || target.closest(`${this.hoveredSelectors}`)) {
        this.cursorOut();
      }
    });
  }

  /** Toggle cursor hover state by scroll event */
  toggleHoverStateOnScroll() {
    window.addEventListener('scroll', () => {
      this.hoveredElems.forEach((el, i) => {
        const coords = el.getBoundingClientRect();
        const coordLeftTrue = this.cursorLeftPosition > coords.left && this.cursorLeftPosition < coords.right;
        const coordTopTrue = this.cursorTopPosition > coords.top && this.cursorTopPosition < coords.bottom;
        if (coordLeftTrue && coordTopTrue) {
          this.cursorOver();
        } else {
          this.cursorOut();
        }
      });
    });
  }

  /** Hide cursor when mouse leave page */
  toggleCursorVisibility() {
    document.addEventListener('mouseleave', e => {
      this.hideCustomCursor();
    })
    document.addEventListener('mouseenter', e => {
      this.showCustomCursor();
    })
  }

  /** Start custom cursor working */
  init() {
    if (!isTouch()) {
      this.showCustomCursor();
      this.moveCursor();
      this.toggleCursorVisibility();
      this.toggleHoverStateOnScroll();
      this.resetCursor();
      this.toggleHoverState();
    }
  }
}
